import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../../images/location_new/revolutionize.png";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol For Revolutionary Mobile App Development?
            </h2>
            <p>
              Considering why TekRevol is the ideal choice for a strategic
              partnership? That’s because we turn ideas into exceptional apps!
            </p>
            <p>Here’s why you should choose TekRevol:</p>
            <ul>
              <li>
                <strong>Expertise & Experience:</strong> Armed with seasoned
                developers in Swift, Kotlin, Flutter, and React Native, we
                ensure unparalleled mobile expertise.
              </li>
              <li>
                <strong>Communication:</strong> TekRevol uses agile methods,
                transparent communication for real-time insights, and
                collaborative development involvement.
              </li>
              <li>
                <strong>Scalability:</strong> TekRevol ensures seamless app
                growth with scalable architectures, cloud tech, and optimal
                performance.
              </li>
              <li>
                <strong>Technical Proficiency:</strong> TekRevol's developers
                excel in state-of-the-art frameworks, ensuring technical mastery
                for complex projects.
              </li>
              <li>
                <strong>Cost-Effectiveness:</strong> TekRevol optimizes
                efficiency through coding and agile workflows, ensuring
                cost-effectiveness without compromising app quality.
              </li>
            </ul>
            <Link
              to="https://www.tekrevol.com/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
